import { BottomSheet, Flex, Shape, Image, styled } from '@teko/ds-mobile';
import React, { useEffect } from 'react';
import { PopupTerminalPickerProps } from '..';
import { t } from 'i18n';
import TerminalPicker from '../../../../assets/terminal-picker.png';
import { useDistanceTerminalContext } from 'contexts';
import { ModeEnterAddress } from './ModeEnterAddress';
import { ModeListTerminal } from './ModeListTerminal';

export const PopupTerminalPickerMobile: React.FC<PopupTerminalPickerProps> = ({
  showPopup,
  onClosePopup,
}) => {
  const {
    isModeEnterAddress,
    currentTerminal,
    locationGetDistanceTerminals,
    currentTerminals,
    setTemporaryDataDistanceTerminal,
    temporaryDataDistanceTerminal,
  } = useDistanceTerminalContext();

  useEffect(() => {
    if (!!showPopup) {
      setTemporaryDataDistanceTerminal?.({
        ...temporaryDataDistanceTerminal,
        terminals:
          !!currentTerminals && Array.isArray(currentTerminals)
            ? currentTerminals
            : [],
        ...(locationGetDistanceTerminals
          ? { location: locationGetDistanceTerminals }
          : {}),
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentTerminals, locationGetDistanceTerminals, showPopup]);

  return (
    <StyledBottomSheet
      show={showPopup}
      position={'bottom'}
      zIndex={2000}
      closeBottomSheet={!!currentTerminal ? onClosePopup : undefined}
      contentHeight="78vh"
      title={t('Chọn khu vực của bạn')}
    >
      <Flex
        padding="s16"
        direction="column"
        gap="s12"
        align="center"
        justify="center"
      >
        <Shape paddingBottom="s16">
          <Image height="72px" width="116px" src={TerminalPicker} />
        </Shape>
        {isModeEnterAddress ? <ModeEnterAddress /> : <ModeListTerminal />}
      </Flex>
    </StyledBottomSheet>
  );
};

const StyledBottomSheet = styled(BottomSheet)`
  width: 100%;
`;
